export default __webpack_public_path__ + "static/media/remove.44145df9bb3d4fb999c3825ab5b2bacf.svg";